import { useCanvasStore } from './canvasStore';
import { useEditorStore } from './editorStore';

/** Undo the last wall point while tracing, otherwise undo the last committed edit. */
export function undoEditor(): 'wall' | 'canvas' | 'none' {
  const { draftWallPoints, setDraftWallPoints } = useEditorStore.getState();
  if (draftWallPoints && draftWallPoints.length > 0) {
    setDraftWallPoints(draftWallPoints.length === 1 ? null : draftWallPoints.slice(0, -1));
    return 'wall';
  }
  const { historyIndex, undo } = useCanvasStore.getState();
  if (historyIndex <= 0) return 'none';
  undo();
  return 'canvas';
}

export function redoEditor(): boolean {
  const draft = useEditorStore.getState().draftWallPoints;
  if (draft && draft.length > 0) return false;
  const { historyIndex, history, redo } = useCanvasStore.getState();
  if (historyIndex >= history.length - 1) return false;
  redo();
  return true;
}

export function canUndoEditor(): boolean {
  const draft = useEditorStore.getState().draftWallPoints;
  if (draft && draft.length > 0) return true;
  return useCanvasStore.getState().historyIndex > 0;
}
